import * as React from 'react';
import type { SVGProps } from 'react';
const Svg404Error = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 338 250"
    {...props}
  >
    <path
      fill="#6C7DC0"
      d="M168.592 26.687c-49.686 22.347-4.583 62.168-33.272 83.867-28.69 21.698-106.687-3.379-76.956 52.937 34.929 66.162 187.881 56.972 220.863-24.178S218.278 4.333 168.592 26.687Z"
    />
    <path
      fill="#fff"
      d="M168.592 26.687c-49.686 22.347-4.583 62.168-33.272 83.867-28.69 21.698-106.687-3.379-76.956 52.937 34.929 66.162 187.881 56.972 220.863-24.178S218.278 4.333 168.592 26.687Z"
      opacity={0.9}
    />
    <path
      fill="#F5F5F5"
      d="M168.999 234.463c72.388 0 131.07-3.425 131.07-7.65 0-4.224-58.682-7.649-131.07-7.649-72.387 0-131.07 3.425-131.07 7.649 0 4.225 58.683 7.65 131.07 7.65Z"
    />
    <path
      fill="#6C7DC0"
      d="m174.023 146.915-45.793.79 58.637-45.869-12.844 45.079Z"
    />
    <path
      fill="#FAFAFA"
      d="m174.023 146.915-45.793.79 58.637-45.869-12.844 45.079Z"
      opacity={0.6}
    />
    <path
      fill="#6C7DC0"
      d="M122.594 147.934c37.466 0 67.837-30.36 67.837-67.81 0-37.452-30.371-67.811-67.837-67.811-37.465 0-67.836 30.36-67.836 67.81 0 37.451 30.371 67.811 67.836 67.811Z"
    />
    <path
      fill="#FAFAFA"
      d="M122.594 147.934c37.466 0 67.837-30.36 67.837-67.81 0-37.452-30.371-67.811-67.837-67.811-37.465 0-67.836 30.36-67.836 67.81 0 37.451 30.371 67.811 67.836 67.811Z"
      opacity={0.7}
    />
    <path
      fill="#6C7DC0"
      d="m103.042 103.249-6.455-.608-.791 8.352-4.732-.446.784-8.345-18.84-1.777.318-3.38L92.8 76.45l5.246.493L79.369 96.83l13.067 1.23.676-7.38 4.563.433L97 98.492l6.456.601-.413 4.156ZM106.769 94.884c1.048-11.062 7.564-16.819 15.548-16.069 7.983.75 13.222 7.616 12.208 18.678-1.014 11.062-7.557 16.819-15.473 16.076-7.916-.744-13.324-7.616-12.283-18.685Zm22.869 2.156c.818-8.69-2.461-13.407-7.747-13.907s-9.464 3.52-10.262 12.21c-.797 8.691 2.461 13.401 7.801 13.908 5.341.506 9.39-3.555 10.208-12.211ZM167.919 109.351l-6.463-.608-.784 8.352-4.732-.446.791-8.346-18.887-1.777.317-3.379 19.476-20.596 5.246.493-18.678 19.887 13.06 1.23.676-7.38 4.563.433-.676 7.38 6.463.608-.372 4.149ZM96.84 62.935l-.284 3.04-12.689-1.195 1.541-16.374 12.385 1.163-.29 3.04-8.613-.81-.331 3.56 7.605.717-.278 2.946-7.605-.716-.358 3.79 8.917.839ZM110.012 67.24l-2.704-4.858h-.183l-3.305-.31-.426 4.56-3.792-.358 1.541-16.38 7.091.676c4.381.413 6.902 2.94 6.557 6.616a5.353 5.353 0 0 1-3.86 4.852l3.184 5.608-4.103-.405Zm-2.305-13.622-3.09-.29-.507 5.743 3.09.29c2.318.217 3.589-.75 3.758-2.527.169-1.777-.933-3-3.251-3.216ZM127.211 68.86 124.507 64h-.189l-3.299-.31-.433 4.56-3.785-.358 1.501-16.393 7.091.676c4.373.412 6.895 2.932 6.55 6.608a5.33 5.33 0 0 1-3.853 4.852l3.177 5.609-4.056-.385Zm-2.312-13.623-3.089-.29-.534 5.703 3.089.29c2.319.223 3.59-.743 3.759-2.52.169-1.778-.906-2.967-3.225-3.183ZM133.716 61.211c.46-4.865 4.59-8.109 9.762-7.629 5.171.48 8.626 4.426 8.166 9.312-.46 4.886-4.617 8.109-9.761 7.629-5.145-.48-8.626-4.446-8.167-9.312Zm14.088 1.352a5.145 5.145 0 0 0-2.785-4.978 5.153 5.153 0 0 0-7.296 3.14 5.15 5.15 0 0 0 4.464 6.568 5.014 5.014 0 0 0 5.617-4.757v.027ZM164.16 72.336l-2.704-4.859h-.182l-3.306-.304-.426 4.561-3.792-.358 1.541-16.38 7.092.676c4.373.412 6.901 2.94 6.557 6.609a5.35 5.35 0 0 1-3.86 4.858l3.184 5.609-4.104-.412Zm-2.305-13.623-3.089-.29-.541 5.71 3.089.29c2.319.216 3.59-.75 3.759-2.528.169-1.777-.899-2.966-3.218-3.182ZM225.153 59.746h28.886a5.98 5.98 0 0 1 5.527 3.686c.3.725.455 1.503.455 2.288v10.136a5.985 5.985 0 0 1-1.752 4.226 5.988 5.988 0 0 1-4.23 1.748H234.84l-8.788 9.392 4.732-9.392h-5.665a5.98 5.98 0 0 1-5.527-3.686 5.985 5.985 0 0 1-.455-2.288V65.72a5.979 5.979 0 0 1 6.016-5.974Z"
    />
    <path
      fill="#fff"
      d="M226.569 70.21a3.424 3.424 0 0 1 4.011-3.503 3.424 3.424 0 0 1 1.338 6.21 3.429 3.429 0 0 1-1.915.591 3.267 3.267 0 0 1-2.429-.908 3.269 3.269 0 0 1-1.005-2.39Zm5.928 0a2.505 2.505 0 0 0-2.981-2.495 2.511 2.511 0 0 0-1.985 1.968 2.505 2.505 0 0 0 2.472 3 2.432 2.432 0 0 0 1.777-.702 2.424 2.424 0 0 0 .717-1.77ZM234.247 70.994a2.547 2.547 0 0 1 1.536-2.38 2.542 2.542 0 1 1 1.006 4.874 2.426 2.426 0 0 1-2.542-2.494Zm4.185 0a1.652 1.652 0 0 0-2.84-1.072 1.65 1.65 0 0 0-.324 1.79 1.647 1.647 0 0 0 1.521.999 1.608 1.608 0 0 0 1.643-1.717ZM245.603 70.99a2.366 2.366 0 0 1-2.467 2.493 2.093 2.093 0 0 1-1.704-.79v2.521h-.885v-6.683h.845v.777a2.087 2.087 0 0 1 1.744-.817 2.364 2.364 0 0 1 2.467 2.5Zm-.892 0a1.647 1.647 0 0 0-2.011-1.54 1.652 1.652 0 0 0-1.259 1.31 1.647 1.647 0 0 0 1.621 1.947 1.618 1.618 0 0 0 1.649-1.716ZM246.211 72.911l.365-.675a3.198 3.198 0 0 0 1.717.507c.818 0 1.156-.25 1.156-.676 0-1.102-3.083-.149-3.083-2.095 0-.872.785-1.46 2.028-1.46a3.55 3.55 0 0 1 1.778.44l-.378.675a2.495 2.495 0 0 0-1.406-.392c-.778 0-1.156.29-1.156.676 0 1.149 3.096.21 3.096 2.108 0 .886-.811 1.447-2.109 1.447a3.496 3.496 0 0 1-2.008-.555ZM251.238 72.897a.594.594 0 0 1 .376-.555.585.585 0 0 1 .233-.04.594.594 0 0 1 0 1.183.6.6 0 0 1-.56-.36.6.6 0 0 1-.049-.228Zm.081-5.913h1.041l-.175 4.413h-.676l-.19-4.413ZM175.176 142.318c.27.277-.575 1.521-1.879 2.784-1.305 1.264-2.583 2.028-2.846 1.778-.264-.251.574-1.521 1.879-2.778 1.305-1.257 2.582-2.054 2.846-1.784Z"
    />
    <path
      fill="#6C7DC0"
      d="m176.88 145.457 14.993 15.542a.84.84 0 0 1 .184.922.847.847 0 0 1-.184.274l-2.129 2.027a.854.854 0 0 1-.602.252.847.847 0 0 1-.601-.252l-14.994-15.542 3.333-3.223Z"
    />
    <path
      fill="#6C7DC0"
      d="m177.57 146.205-1.968-3.689-4.961 4.791 3.616 2.094 3.313-3.196Z"
    />
    <path
      fill="#000"
      d="m177.57 146.205-1.968-3.689-4.961 4.791 3.616 2.094 3.313-3.196Z"
      opacity={0.2}
    />
    <path
      fill="#6C7DC0"
      d="m175.239 142.061-5.015 4.838a.23.23 0 0 0-.006.325l.484.501a.23.23 0 0 0 .325.006l5.015-4.838a.23.23 0 0 0 .006-.325l-.484-.501a.23.23 0 0 0-.325-.006Z"
    />
    <path
      fill="#000"
      d="m191.665 160.777.209.217a.837.837 0 0 1 .184.921.852.852 0 0 1-.184.275l-2.129 2.027a.835.835 0 0 1-.602.251.847.847 0 0 1-.601-.251l-.21-.216 3.333-3.224ZM180.19 152.239a.47.47 0 0 1-.152.112.46.46 0 0 1-.524-.112l-2.339-2.426a.455.455 0 0 1-.148-.338.467.467 0 0 1 .148-.338.463.463 0 0 1 .338-.145.463.463 0 0 1 .338.145l2.339 2.419a.46.46 0 0 1 0 .683Z"
      opacity={0.2}
    />
    <path
      fill="#FFC3BD"
      d="M237.362 122.125c4.928 3.44 9.038 7.825 12.763 12.481 3.258 4.102 5.178 9.041 6.685 13.947a68.71 68.71 0 0 1 2.278 10.468l-4.306 1.054c-2.758-6.67-5.57-13.839-10.045-19.421a120.455 120.455 0 0 0-10.722-9.765c-.425-.351-1.352-1.067-1.757-1.412l5.104-7.352Z"
    />
    <path
      fill="#6C7DC0"
      d="M232.074 119.153c7.436-.101 13.797 9.623 13.797 9.623l-7.504 7.919s-7.99-4.554-12.37-8.426c-5.408-4.778.405-9.055 6.077-9.116Z"
    />
    <path
      fill="#fff"
      d="m240.67 123.475-.221.283 2.234 1.741.22-.283-2.233-1.741ZM236.926 120.56l-.514-.398a12.634 12.634 0 0 0-1.189-.467l1.48 1.149.223-.284ZM244.432 126.843l-.29-.359-.068.081.358.278ZM238.322 121.643l-.22.283 2.063 1.608.22-.283-2.063-1.608ZM226.27 121.915l-.73-.567a2.82 2.82 0 0 0-.27.243l.777.608.223-.284ZM233.634 127.632l-.22.282 2.064 1.607.22-.282-2.064-1.607ZM227.67 122.987l-.221.283 2.037 1.587.22-.283-2.036-1.587ZM235.99 129.475l-.22.283 2.234 1.74.22-.282-2.234-1.741ZM229.978 124.772l-.22.283 2.261 1.761.22-.283-2.261-1.761ZM239.398 132.572l1.657 1.29.25-.263-1.683-1.318-.224.291Z"
      opacity={0.4}
    />
    <path
      fill="#000"
      d="m236.444 124.022-1.089 1.396 2.064 1.607 1.089-1.396-2.064-1.607ZM230.475 119.373l-1.088 1.397 2.037 1.586 1.088-1.396-2.037-1.587ZM232.792 121.162l-1.089 1.397 2.261 1.761 1.089-1.397-2.261-1.761ZM241.336 130.076l1.899 1.479 1.224-1.29-2.035-1.581-1.088 1.392ZM238.796 125.857l-1.089 1.397 2.234 1.74 1.089-1.396-2.234-1.741ZM225.811 125.357l-1.088 1.397 2.036 1.587 1.089-1.397-2.037-1.587ZM231.788 130.01l-1.089 1.396 2.064 1.608 1.088-1.397-2.063-1.607ZM223.905 123.859a3.222 3.222 0 0 0 0 1.082l.527-.676-.527-.406ZM236.867 135.816l1.501.878.852-.899-1.454-1.135-.899 1.156ZM234.135 131.836l-1.088 1.392 1.48 1.149.818.513 1.028-1.317-2.238-1.737ZM228.132 127.154l-1.089 1.397 2.261 1.761 1.088-1.396-2.26-1.762Z"
      opacity={0.2}
    />
    <path
      fill="#fff"
      d="M224.523 126.586c.048.075.095.149.15.224l.054-.068-.204-.156ZM230.549 119.273h-.17l.095.075.075-.075ZM227.658 122.968l1.724-2.203-1.176-.878-.507.196-1.433 1.831 1.392 1.054ZM226.047 122.18l-1.629 2.09 1.397 1.088 1.629-2.09-1.397-1.088Z"
      opacity={0.2}
    />
    <path
      fill="#fff"
      d="m226.263 121.889-.22.283 1.397 1.088.22-.282-1.397-1.089Z"
      opacity={0.4}
    />
    <path
      fill="#fff"
      d="m226.263 121.889-.22.283 1.397 1.088.22-.282-1.397-1.089Z"
      opacity={0.2}
    />
    <path
      fill="#000"
      d="m230.476 119.375-.095-.074c-.74.113-1.467.299-2.17.554l1.176.912 1.089-1.392Z"
      opacity={0.2}
    />
    <path
      fill="#fff"
      d="m230.476 119.375-.095-.074c-.74.113-1.467.299-2.17.554l1.176.912 1.089-1.392Z"
      opacity={0.2}
    />
    <path
      fill="#000"
      d="m224.727 126.742 1.082-1.392-1.379-1.088-.528.675a4.28 4.28 0 0 0 .636 1.643l.189.162Z"
      opacity={0.2}
    />
    <path
      fill="#fff"
      d="m224.727 126.742 1.082-1.392-1.379-1.088-.528.675a4.28 4.28 0 0 0 .636 1.643l.189.162ZM232.023 126.833l-1.628 2.089 1.397 1.088 1.628-2.089-1.397-1.088ZM238.322 121.622l.237-.297a16.12 16.12 0 0 0-1.541-.899l-.088.108 1.392 1.088ZM236.705 120.804l-1.654 2.122 1.397 1.088 1.654-2.121-1.397-1.089ZM233.97 124.325l-1.72 2.206 1.397 1.089 1.72-2.207-1.397-1.088ZM229.311 130.309l-.284.364c.474.345.954.676 1.44 1.028l.237-.304-1.393-1.088Z"
      opacity={0.2}
    />
    <path
      fill="#fff"
      d="m236.927 120.542-.22.282 1.397 1.089.22-.283-1.397-1.088Z"
      opacity={0.4}
    />
    <path
      fill="#fff"
      d="m236.927 120.542-.22.282 1.397 1.089.22-.283-1.397-1.088Z"
      opacity={0.2}
    />
    <path
      fill="#fff"
      d="m232.24 126.546-.22.282 1.397 1.088.22-.282-1.397-1.088Z"
      opacity={0.4}
    />
    <path
      fill="#fff"
      d="m232.24 126.546-.22.282 1.397 1.088.22-.282-1.397-1.088Z"
      opacity={0.2}
    />
    <path
      fill="#000"
      d="m235.054 122.951-1.089 1.397 1.397 1.088 1.089-1.397-1.397-1.088Z"
      opacity={0.2}
    />
    <path
      fill="#fff"
      d="m235.054 122.951-1.089 1.397 1.397 1.088 1.089-1.397-1.397-1.088Z"
      opacity={0.2}
    />
    <path
      fill="#000"
      d="m230.397 128.924-1.088 1.396 1.397 1.089 1.088-1.397-1.397-1.088Z"
      opacity={0.2}
    />
    <path
      fill="#fff"
      d="m230.397 128.924-1.088 1.396 1.397 1.089 1.088-1.397-1.397-1.088ZM243.261 125.477l-.311-.344-.048.061.359.283ZM242.689 125.496l-1.654 2.121 1.397 1.088 1.654-2.121-1.397-1.088ZM238 131.469l-1.629 2.09 1.397 1.088 1.629-2.089-1.397-1.089ZM239.943 128.993l-1.72 2.206 1.397 1.089 1.72-2.207-1.397-1.088Z"
      opacity={0.2}
    />
    <path
      fill="#fff"
      d="m242.68 125.479 1.392 1.088.068-.081c-.264-.318-.561-.676-.879-1.007l-.358-.284-.223.284Z"
      opacity={0.4}
    />
    <path
      fill="#fff"
      d="m242.68 125.479 1.392 1.088.068-.081c-.264-.318-.561-.676-.879-1.007l-.358-.284-.223.284Z"
      opacity={0.2}
    />
    <path
      fill="#fff"
      d="m238.216 131.19-.22.283 1.397 1.088.22-.283-1.397-1.088Z"
      opacity={0.4}
    />
    <path
      fill="#fff"
      d="m238.216 131.19-.22.283 1.397 1.088.22-.283-1.397-1.088Z"
      opacity={0.2}
    />
    <path
      fill="#000"
      d="M241.03 127.604 239.941 129l1.397 1.088 1.089-1.396-1.397-1.088Z"
      opacity={0.2}
    />
    <path
      fill="#fff"
      d="M241.03 127.604 239.941 129l1.397 1.088 1.089-1.396-1.397-1.088Z"
      opacity={0.2}
    />
    <path
      fill="#000"
      d="m236.375 133.57-1.027 1.318 1.521.926.899-1.156-1.393-1.088Z"
      opacity={0.2}
    />
    <path
      fill="#fff"
      d="m236.375 133.57-1.027 1.318 1.521.926.899-1.156-1.393-1.088Z"
      opacity={0.2}
    />
    <path
      fill="#000"
      d="m226.765 128.328-.304.345.277.23.291-.365-.264-.21ZM231.416 122.356l-1.721 2.206.283.221 1.72-2.207-.282-.22ZM229.473 124.844l-1.629 2.09.282.22 1.629-2.09-.282-.22ZM232.791 121.176l1.399-1.797a3.635 3.635 0 0 0-.399-.074l-1.291 1.648.291.223Z"
      opacity={0.3}
    />
    <path
      fill="#fff"
      d="m229.697 124.569-.22.283.282.22.22-.283-.282-.22Z"
      opacity={0.4}
    />
    <path
      fill="#000"
      d="m229.697 124.569-.22.283.282.22.22-.283-.282-.22Z"
      opacity={0.3}
    />
    <path
      fill="#000"
      d="m232.511 120.971-1.089 1.396.282.22 1.089-1.396-.282-.22Z"
      opacity={0.2}
    />
    <path
      fill="#000"
      d="m232.511 120.971-1.089 1.396.282.22 1.089-1.396-.282-.22Z"
      opacity={0.3}
    />
    <path
      fill="#000"
      d="m227.843 126.936-1.089 1.396.283.22 1.088-1.396-.282-.22Z"
      opacity={0.2}
    />
    <path
      fill="#000"
      d="m227.843 126.936-1.089 1.396.283.22 1.088-1.396-.282-.22ZM235.488 129.528l-1.629 2.089.283.22 1.629-2.089-.283-.22ZM240.651 123.456l.243-.317-.27-.237-.257.331.284.223ZM232.766 133l-.121.162.297.196.108-.135-.284-.223ZM240.162 123.511l-1.654 2.122.282.22 1.654-2.121-.282-.221ZM237.427 127.039l-1.72 2.207.283.22 1.72-2.206-.283-.221Z"
      opacity={0.3}
    />
    <path
      fill="#fff"
      d="m240.38 123.233-.22.283.283.22.22-.283-.283-.22Z"
      opacity={0.4}
    />
    <path
      fill="#000"
      d="m240.38 123.233-.22.283.283.22.22-.283-.283-.22Z"
      opacity={0.3}
    />
    <path
      fill="#fff"
      d="m235.709 129.264-.221.283.283.22.22-.282-.282-.221Z"
      opacity={0.4}
    />
    <path
      fill="#000"
      d="m235.709 129.264-.221.283.283.22.22-.282-.282-.221Z"
      opacity={0.3}
    />
    <path
      fill="#000"
      d="m238.511 125.639-1.089 1.396.282.22 1.089-1.396-.282-.22Z"
      opacity={0.2}
    />
    <path
      fill="#000"
      d="m238.511 125.639-1.089 1.396.282.22 1.089-1.396-.282-.22Z"
      opacity={0.3}
    />
    <path
      fill="#000"
      d="m233.866 131.635-1.089 1.396.283.22 1.089-1.396-.283-.22Z"
      opacity={0.2}
    />
    <path
      fill="#000"
      d="m233.866 131.635-1.089 1.396.283.22 1.089-1.396-.283-.22ZM245.87 128.772l-.074-.108-.784 1.014.858-.906Z"
      opacity={0.3}
    />
    <path
      fill="#6C7DC0"
      d="m236.996 136.368 7.842-10.13 1.872 2.129-8.173 9.203-1.541-1.202Z"
    />
    <path
      fill="#fff"
      d="m246.71 128.367-2.927 3.297-5.009 5.643-.237.27-1.541-1.209.095-.122.162-.203 4.874-6.298 2.278-2.946.433-.561 1.872 2.129Z"
      opacity={0.2}
    />
    <path
      fill="#000"
      d="m243.785 131.666-5.009 5.642a7.777 7.777 0 0 1-1.683-1.061 6.7 6.7 0 0 1-.805-.784c-1.696-1.946-2.501-5.021-.811-9.217a17.665 17.665 0 0 1 6.652 3.5c.515.459.98.971 1.386 1.528.098.125.188.256.27.392Z"
      opacity={0.2}
    />
    <path
      fill="#263238"
      d="M206.394 106.67c-.041.426-.358.73-.636.676-.277-.054-.439-.426-.378-.852.061-.425.358-.729.635-.675.278.054.44.446.379.851Z"
    />
    <path
      fill="#ED847E"
      d="M206.673 107.109a15.61 15.61 0 0 1-2.63 3.312 2.523 2.523 0 0 0 1.981.716l.649-4.028Z"
    />
    <path
      fill="#263238"
      d="M206.274 104.118a.244.244 0 0 0-.183.059.242.242 0 0 0-.087.171c.007.05.028.096.061.135a.249.249 0 0 0 .066.088c.028.025.06.043.096.054a2.029 2.029 0 0 1 1.568.939.27.27 0 0 0 .345.115.254.254 0 0 0 .124-.146c.011-.032.014-.065.011-.098a.237.237 0 0 0-.027-.094 2.493 2.493 0 0 0-1.974-1.223Z"
    />
    <path
      fill="#FFC3BD"
      d="M205.724 113.048c.036.264.085.526.149.784a7.478 7.478 0 0 0 2.265 3.859c.284.262.589.502.912.716a6.813 6.813 0 0 0 8.221-.372c3.015-2.419 3.298-5.581 4.211-10.886a7.371 7.371 0 0 0-5.567-8.529 7.38 7.38 0 0 0-3.708.089c-5.475 1.541-7.098 9.4-6.483 14.339Z"
    />
    <path
      fill="#000"
      d="M208.141 117.689c.284.263.589.502.912.716a6.818 6.818 0 0 0 5.814.919 8.173 8.173 0 0 0-.744-1.919 10.635 10.635 0 0 0-5.982.284Z"
      opacity={0.2}
    />
    <path
      fill="#FFC3BD"
      d="M221.999 121.57c-1.203 3.446-7.436 5.805-7.436 5.805s-4.171.973-4.022-.568c1.947-1.514 2.433-3.075 2.17-4.582a7.046 7.046 0 0 0-1.109-2.554c-.277-.439-1.548-1.682-1.879-2.088l5.245-8.399c.967 4.02 3.326 11.102 7.031 12.386Z"
    />
    <path
      fill="#263238"
      d="M212.154 96.342c1.46-.44 5.408-.676 7.726.203 7.132 2.81 5.74 7.014 5.74 7.014a5.147 5.147 0 0 0-1.663-2.27c4.887 10.291-5.672 16.413-5.672 16.413-2.778-1.709-6.801-1.182-6.801-1.182s-.243-4.933-1.352-6.65c-1.108-1.716-1.487-5.115-.784-6.899.703-1.784-1.264-1.149-1.264-1.149-1.183-1.459 1.934-4.838 4.07-5.48Z"
    />
    <path
      fill="#FFC3BD"
      d="M212.168 109.246a3.492 3.492 0 0 1-2.028 2.169c-1.143.338-1.684-1.277-1.352-2.865.311-1.406 1.277-3.325 2.406-2.926 1.129.398 1.515 2.223.974 3.622Z"
    />
    <path
      fill="#000"
      d="M210.87 100.906s-4.732 11.258-3.697 15.725c0 0-2.204-3.318 2.67-15.542l1.027-.183Z"
    />
    <path
      fill="#6C7DC0"
      d="M214.824 100.801s2.623 5.811 5.523 7.852c2.9 2.041 4.8.581 4.8.581l.946-3.608s-.96 2.703-2.352 2.446c-1.393-.257-4.137-2.027-6.307-6.818l-2.61-.453Z"
    />
    <path
      fill="#fff"
      d="M214.824 100.801s2.623 5.811 5.523 7.852c2.9 2.041 4.8.581 4.8.581l.946-3.608s-.96 2.703-2.352 2.446c-1.393-.257-4.137-2.027-6.307-6.818l-2.61-.453Z"
      opacity={0.4}
    />
    <path
      fill="#6C7DC0"
      d="M206.297 101.46s1.568-5.196 4.455-6.757c2.886-1.561 9.065-.622 12.391 1.696 3.326 2.318 3.447 7.832 3.211 8.852-.548 2.365-7.362-4.879-12.804-4.98-5.441-.101-7.253 1.189-7.253 1.189Z"
    />
    <path
      fill="#000"
      d="M206.297 101.46s1.568-5.196 4.455-6.757c2.886-1.561 9.065-.622 12.391 1.696 3.326 2.318 3.447 7.832 3.211 8.852-.548 2.365-7.362-4.879-12.804-4.98-5.441-.101-7.253 1.189-7.253 1.189Z"
      opacity={0.2}
    />
    <path
      fill="#6C7DC0"
      d="M211.633 94.31s1.271-2.385 2.312-2.702c1.041-.318 7.882 1.446 9.538 3.014 1.656 1.567 3.238 6.27 2.163 10.663l-3.346-.811s.825-5.136-1.474-7.568c-2.65-2.818-9.193-2.595-9.193-2.595Z"
    />
    <path
      fill="#6C7DC0"
      d="M203.762 103.394s2.332 1.615 5.631-.737c3.299-2.351 7.821-.817 11.019 1.352a23.96 23.96 0 0 0 7.436 3.378l-1.467-2.169s-2.806-.412-6.76-3.574c-3.955-3.163-11.006-2.467-13.318-.196l-2.541 1.946ZM210.844 124.213s3.339-5.244 9.112-5.69c5.773-.446 3.752 5.69 3.752 5.69h-12.864Z"
    />
    <path
      fill="#fff"
      d="M210.844 124.213s3.339-5.244 9.112-5.69c5.773-.446 3.752 5.69 3.752 5.69h-12.864Z"
      opacity={0.2}
    />
    <path
      fill="#6C7DC0"
      d="M247.258 151.892c-8.491 2.703-24.059 7.703-28.19 9.034-.96-2.547-.175-10.237-4.475-18.657a33.047 33.047 0 0 0-4.887-7.048 39.996 39.996 0 0 0-6.808-5.967s12.202-10.717 27.473-9.778c0 0 12.986 7.927 16.887 32.416Z"
    />
    <path
      fill="#fff"
      d="m222.324 122.841-2.722.897.112.34 2.722-.897-.112-.34ZM219.257 123.856l-2.452.808.112.34 2.452-.808-.112-.34ZM215.116 125.231l-2.761.91.113.34 2.76-.91-.112-.34ZM204.784 128.633l-1.886.621.359.264 1.649-.547-.122-.338ZM212.02 126.256l-2.415.795.113.34 2.414-.795-.112-.34ZM229.514 120.489l-2.69.886.112.34 2.69-.886-.112-.34ZM226.477 121.486l-2.485.819.112.34 2.485-.819-.112-.34ZM207.925 127.583l-2.792.921.112.34 2.793-.92-.113-.341ZM231.424 120.233l-.17-.135.054.169.116-.034ZM221.644 131.067l-2.453.808.113.34 2.452-.808-.112-.34ZM217.507 132.434l-2.761.91.112.34 2.761-.91-.112-.34ZM224.699 130.088l-2.722.896.112.341 2.722-.897-.112-.34ZM228.864 128.721l-2.485.818.112.34 2.485-.818-.112-.34ZM236.553 126.558l.676-.223-.229-.304-.555.183.108.344ZM231.905 127.707l-2.69.887.112.34 2.69-.887-.112-.34ZM236.101 126.337l-2.523.831.112.34 2.523-.831-.112-.34ZM214.402 133.462l-2.414.796.112.34 2.414-.796-.112-.34ZM210.307 134.82l-.737.244c.088.101.169.202.257.297l.595-.196-.115-.345ZM238.488 133.539l-2.523.832.112.34 2.523-.831-.112-.341ZM219.897 139.664l-2.76.91.112.34 2.761-.91-.113-.34ZM234.292 134.918l-2.69.887.112.34 2.69-.887-.112-.34ZM227.093 137.298l-2.722.897.112.34 2.722-.897-.112-.34ZM231.254 135.914l-2.484.82.112.34 2.484-.82-.112-.34ZM216.793 140.681l-2.414.796.112.34 2.414-.796-.112-.34ZM238.932 133.783l2.407-.791a7.173 7.173 0 0 1-.169-.324l-2.346.777.108.338ZM223.481 139.071l-2.454.8.111.34 2.454-.8-.111-.34ZM229.457 144.549l-2.723.896.113.34 2.722-.896-.112-.34ZM233.641 143.154l-2.485.819.112.34 2.485-.819-.112-.34ZM243.862 139.782l-2.651.874.112.34 2.652-.874-.113-.34ZM240.879 140.754l-2.524.832.113.34 2.523-.832-.112-.34ZM219.168 147.93l-2.129.675c0 .122.061.237.095.352l2.149-.71-.115-.317ZM226.406 145.543l-2.453.809.112.34 2.453-.809-.112-.34ZM222.28 146.899l-2.76.91.112.34 2.76-.91-.112-.34ZM236.674 142.152l-2.69.887.113.34 2.69-.886-.113-.341ZM236.016 150.404l-2.485.819.112.34 2.485-.819-.112-.34ZM224.659 154.153l-2.761.909.113.341 2.76-.91-.112-.34ZM231.847 151.775l-2.722.897.112.34 2.722-.897-.112-.34ZM221.562 155.15l-2.414.795.113.34 2.414-.795-.113-.34ZM246.249 147.009l-2.651.874.112.34 2.651-.874-.112-.34ZM228.796 152.758l-2.452.808.112.341 2.452-.809-.112-.34ZM243.261 147.993l-2.523.831.112.34 2.524-.831-.113-.34ZM239.049 149.407l-2.69.886.113.34 2.69-.886-.113-.34Z"
      opacity={0.4}
    />
    <path
      fill="#000"
      d="m218.405 121.314-.101-.318c-.839.257-1.657.534-2.441.831l.095.291 2.447-.804ZM221.474 120.3l-.034-.109c-.953.203-1.886.44-2.792.676l.102.304 2.724-.871ZM214.217 122.477c-.636.27-1.251.547-1.846.831l1.913-.635-.067-.196ZM219.731 127.567l-2.454.8.549 1.682 2.454-.8-.549-1.682ZM223.285 125.821l-2.723.898.555 1.681 2.722-.897-.554-1.682ZM208.882 130.555l-2.792.925.115.359c.412.358.818.709 1.196 1.067l2.028-.675-.547-1.676ZM232.724 124.572l2.413-.797a27.568 27.568 0 0 0-1.352-1.42l-1.629.541.568 1.676ZM230.495 123.422l-2.69.887.554 1.681 2.69-.887-.554-1.681ZM227.461 124.427l-2.484.819.554 1.681 2.485-.818-.555-1.682ZM213 129.2l-2.414.796.555 1.681 2.414-.795L213 129.2ZM216.104 128.176l-2.76.91.554 1.681 2.761-.91-.555-1.681ZM229.84 131.622l-2.485.819.555 1.682 2.485-.819-.555-1.682ZM218.479 135.383l-2.76.91.554 1.681 2.761-.91-.555-1.681ZM222.078 134.774l-2.453.8.549 1.682 2.453-.8-.549-1.682ZM237.949 130.82l1.845-.608a34.456 34.456 0 0 0-.96-1.548l-1.439.473.554 1.683ZM225.667 133.013l-2.722.897.555 1.682 2.722-.898-.555-1.681ZM232.866 130.637l-2.69.886.554 1.682 2.69-.887-.554-1.681ZM215.375 136.396l-2.414.795.555 1.682 2.414-.796-.555-1.681ZM237.074 129.246l-2.523.832.554 1.682 2.523-.832-.554-1.682ZM228.035 140.193l-2.723.897.555 1.681 2.722-.897-.554-1.681ZM224.426 141.973l-2.453.8.549 1.682 2.453-.8-.549-1.682ZM217.748 143.598l-2.197.723c.23.554.453 1.101.676 1.649l2.095-.676-.574-1.696ZM239.445 136.442l-2.523.831.555 1.682 2.523-.832-.555-1.681ZM220.854 142.559l-2.76.91.554 1.681 2.761-.91-.555-1.681ZM232.215 138.814l-2.485.819.555 1.681 2.485-.819-.555-1.681ZM235.237 137.828l-2.69.887.555 1.681 2.689-.886-.554-1.682ZM242.429 135.47l-2.652.874.555 1.681 2.651-.874-.554-1.681ZM234.009 146.83l-2.486.811.549 1.682 2.486-.811-.549-1.682ZM227.351 148.406l-2.453.809.555 1.681 2.453-.808-.555-1.682ZM244.812 142.638l-2.652.874.555 1.681 2.651-.874-.554-1.681ZM223.229 149.758l-2.76.91.554 1.681 2.761-.91-.555-1.681ZM220.662 152.473l-.547-1.676-2.4.784c0 .054 0 .101.034.155l.5 1.534 2.413-.797ZM241.812 143.621l-2.523.832.555 1.682 2.523-.832-.555-1.682ZM237.612 145.008l-2.69.887.555 1.681 2.689-.887-.554-1.681Z"
      opacity={0.2}
    />
    <path
      fill="#000"
      d="m229.844 148.17-2.723.889.549 1.682 2.723-.889-.549-1.682ZM229.129 156.383l-2.453.801.549 1.682 2.453-.801-.549-1.682ZM232.188 155.401l-2.723.888.549 1.682 2.723-.888-.549-1.682ZM245.082 152.404l2.143-.71a61.504 61.504 0 0 0-.305-1.756l-2.393.783.555 1.683ZM244.187 150.836l-2.523.832.555 1.681 2.523-.831-.555-1.682ZM225.593 156.965l-2.765.905.554 1.669 1.352-.432 1.413-.466-.554-1.676ZM236.942 153.232l-2.485.819.554 1.681 2.485-.818-.554-1.682ZM220.07 158.782l.548 1.642 2.42-.777-.548-1.663-2.42.798Z"
      opacity={0.2}
    />
    <path
      fill="#000"
      d="m239.402 153.029-2.691.877.549 1.682 2.691-.878-.549-1.681Z"
      opacity={0.2}
    />
    <path
      fill="#fff"
      d="m219.248 156.305-.838.277c.102 1.013.189 1.905.291 2.655l1.352-.452-.805-2.48ZM218.249 153.27l-.229.074a67.57 67.57 0 0 1 .358 2.865l.764-.25-.893-2.689ZM214.379 141.877l.318.615-.21-.676-.108.061ZM211.139 131.68l-1.682.554.853 2.587 1.682-.555-.853-2.586ZM209.729 127.367l-1.682.555.866 2.625 1.682-.555-.866-2.625ZM213.506 138.879l-.764.25a31.926 31.926 0 0 1 1.467 2.419l.162-.054-.865-2.615ZM209.603 127.042l-.676-1.96c-.548.318-1.068.635-1.548.933l.514 1.581 1.71-.554ZM212.098 134.613l-1.676.554.48 1.46c.27.331.534.676.777.993l1.271-.419-.852-2.588Z"
      opacity={0.2}
    />
    <path
      fill="#fff"
      d="m209.6 127.047-1.682.555.112.34 1.682-.554-.112-.341Z"
      opacity={0.4}
    />
    <path
      fill="#fff"
      d="m209.6 127.047-1.682.555.112.34 1.682-.554-.112-.341Z"
      opacity={0.2}
    />
    <path
      fill="#fff"
      d="m211.998 134.246-1.682.555.113.34 1.682-.555-.113-.34Z"
      opacity={0.4}
    />
    <path
      fill="#fff"
      d="m211.998 134.246-1.682.555.113.34 1.682-.555-.113-.34Z"
      opacity={0.2}
    />
    <path
      fill="#fff"
      d="m214.373 141.512-.162.054.169.324.108-.034-.115-.344Z"
      opacity={0.4}
    />
    <path
      fill="#fff"
      d="m214.373 141.512-.162.054.169.324.108-.034-.115-.344Z"
      opacity={0.2}
    />
    <path
      fill="#fff"
      d="m219.143 155.961-.764.25c0 .128 0 .25.034.372l.838-.277-.108-.345Z"
      opacity={0.4}
    />
    <path
      fill="#fff"
      d="m219.143 155.961-.764.25c0 .128 0 .25.034.372l.838-.277-.108-.345Z"
      opacity={0.2}
    />
    <path
      fill="#000"
      d="m210.58 130.012-1.682.554.555 1.682 1.682-.555-.555-1.681Z"
      opacity={0.2}
    />
    <path
      fill="#fff"
      d="m210.58 130.012-1.682.554.555 1.682 1.682-.555-.555-1.681Z"
      opacity={0.2}
    />
    <path
      fill="#000"
      d="m212.935 137.199-1.271.419c.379.507.73 1.007 1.061 1.514l.764-.25-.554-1.683Z"
      opacity={0.2}
    />
    <path
      fill="#fff"
      d="m212.935 137.199-1.271.419c.379.507.73 1.007 1.061 1.514l.764-.25-.554-1.683Z"
      opacity={0.2}
    />
    <path
      fill="#000"
      d="M217.75 151.734c.101.548.189 1.088.27 1.609l.23-.075-.5-1.534Z"
      opacity={0.2}
    />
    <path
      fill="#fff"
      d="M217.75 151.734c.101.548.189 1.088.27 1.609l.23-.075-.5-1.534Z"
      opacity={0.2}
    />
    <path
      fill="#000"
      d="M218.703 159.238c.06.572.183 1.137.365 1.683l1.548-.494-.547-1.642-1.366.453Z"
      opacity={0.2}
    />
    <path
      fill="#fff"
      d="M218.703 159.238c.06.572.183 1.137.365 1.683l1.548-.494-.547-1.642-1.366.453ZM218.338 129.301l-1.682.554.853 2.587 1.682-.555-.853-2.586ZM219.299 132.231l-1.682.554.853 2.586 1.682-.554-.853-2.586ZM224.08 146.684l-1.682.554.83 2.516 1.682-.554-.83-2.516ZM216.92 125.008l-1.682.554.866 2.625 1.682-.554-.866-2.625ZM224.882 151.662l-1.683.549.878 2.69 1.683-.549-.878-2.69ZM221.69 139.453l-1.682.555.842 2.554 1.682-.554-.842-2.555ZM220.709 136.492l-1.682.555.864 2.618 1.682-.554-.864-2.619ZM223.088 143.692l-1.682.554.877 2.657 1.682-.554-.877-2.657ZM215.967 122.102l-1.682.554.841 2.548 1.682-.554-.841-2.548Z"
      opacity={0.2}
    />
    <path
      fill="#fff"
      d="m226.463 153.922-1.682.555.82 2.483 1.682-.554-.82-2.484Z"
      opacity={0.2}
    />
    <path
      fill="#fff"
      d="m216.811 124.644-1.682.555.112.34 1.682-.555-.112-.34Z"
      opacity={0.4}
    />
    <path
      fill="#fff"
      d="m216.811 124.644-1.682.555.112.34 1.682-.555-.112-.34Z"
      opacity={0.2}
    />
    <path
      fill="#fff"
      d="m219.19 131.883-1.682.555.112.34 1.682-.555-.112-.34Z"
      opacity={0.4}
    />
    <path
      fill="#fff"
      d="m219.19 131.883-1.682.555.112.34 1.682-.555-.112-.34Z"
      opacity={0.2}
    />
    <path
      fill="#fff"
      d="m221.573 139.125-1.682.555.112.34 1.682-.555-.112-.34Z"
      opacity={0.4}
    />
    <path
      fill="#fff"
      d="m221.573 139.125-1.682.555.112.34 1.682-.555-.112-.34Z"
      opacity={0.2}
    />
    <path
      fill="#fff"
      d="m223.959 146.348-1.682.554.113.34 1.682-.554-.113-.34Z"
      opacity={0.4}
    />
    <path
      fill="#fff"
      d="m223.959 146.348-1.682.554.113.34 1.682-.554-.113-.34Z"
      opacity={0.2}
    />
    <path
      fill="#fff"
      d="m226.338 153.598-1.682.554.113.34 1.681-.554-.112-.34Z"
      opacity={0.4}
    />
    <path
      fill="#fff"
      d="m226.338 153.598-1.682.554.113.34 1.681-.554-.112-.34Z"
      opacity={0.2}
    />
    <path
      fill="#000"
      d="m215.959 122.119-.095-.291c-.568.21-1.115.426-1.649.676l.067.196 1.677-.581Z"
      opacity={0.2}
    />
    <path
      fill="#fff"
      d="m215.959 122.119-.095-.291c-.568.21-1.115.426-1.649.676l.067.196 1.677-.581Z"
      opacity={0.2}
    />
    <path
      fill="#000"
      d="m217.776 127.653-1.682.554.554 1.682 1.682-.555-.554-1.681Z"
      opacity={0.2}
    />
    <path
      fill="#fff"
      d="m217.776 127.653-1.682.554.554 1.682 1.682-.555-.554-1.681Z"
      opacity={0.2}
    />
    <path
      fill="#000"
      d="m220.166 134.805-1.682.554.555 1.682 1.682-.555-.555-1.681Z"
      opacity={0.2}
    />
    <path
      fill="#fff"
      d="m220.166 134.805-1.682.554.555 1.682 1.682-.555-.555-1.681Z"
      opacity={0.2}
    />
    <path
      fill="#000"
      d="m222.53 142.02-1.682.554.554 1.682 1.682-.555-.554-1.681Z"
      opacity={0.2}
    />
    <path
      fill="#fff"
      d="m222.53 142.02-1.682.554.554 1.682 1.682-.555-.554-1.681Z"
      opacity={0.2}
    />
    <path
      fill="#000"
      d="m224.901 149.203-1.682.555.554 1.681 1.682-.554-.554-1.682Z"
      opacity={0.2}
    />
    <path
      fill="#fff"
      d="m224.901 149.203-1.682.555.554 1.681 1.682-.554-.554-1.682Z"
      opacity={0.2}
    />
    <path
      fill="#000"
      d="m227.26 156.426-1.682.554.554 1.682 1.683-.554-.555-1.682Z"
      opacity={0.2}
    />
    <path
      fill="#fff"
      d="m227.26 156.426-1.682.554.554 1.682 1.683-.554-.555-1.682ZM228.881 137.098l-1.682.554.843 2.555 1.682-.555-.843-2.554ZM233.659 151.539l-1.682.555.819 2.483 1.682-.554-.819-2.484ZM222.318 122.853l1.676-.554-.804-2.412-.791.135-.926.304.845 2.527Z"
      opacity={0.2}
    />
    <path
      fill="#fff"
      d="m232.077 149.307-1.682.548.878 2.69 1.682-.549-.878-2.689ZM227.909 134.129l-1.682.555.863 2.618 1.682-.555-.863-2.618ZM225.026 127.717l-1.682.549.844 2.587 1.683-.549-.845-2.587ZM233.336 156.269v.074l1.683-.54v-.088l-1.683.554ZM224.12 122.629l-1.682.555.865 2.624 1.682-.554-.865-2.625ZM231.272 144.317l-1.682.554.83 2.516 1.682-.555-.83-2.515Z"
      opacity={0.2}
    />
    <path
      fill="#fff"
      d="m226.506 129.86-1.682.554.853 2.586 1.682-.554-.853-2.586ZM230.284 141.313l-1.682.554.876 2.657 1.682-.554-.876-2.657Z"
      opacity={0.2}
    />
    <path
      fill="#fff"
      d="m223.991 122.305-1.682.554.112.341 1.682-.555-.112-.34Z"
      opacity={0.4}
    />
    <path
      fill="#fff"
      d="m223.991 122.305-1.682.554.112.341 1.682-.555-.112-.34Z"
      opacity={0.2}
    />
    <path
      fill="#fff"
      d="m226.385 129.516-1.682.554.112.34 1.682-.554-.112-.34Z"
      opacity={0.4}
    />
    <path
      fill="#fff"
      d="m226.385 129.516-1.682.554.112.34 1.682-.554-.112-.34Z"
      opacity={0.2}
    />
    <path
      fill="#fff"
      d="m228.776 136.746-1.682.555.112.34 1.682-.555-.112-.34Z"
      opacity={0.4}
    />
    <path
      fill="#fff"
      d="m228.776 136.746-1.682.555.112.34 1.682-.555-.112-.34Z"
      opacity={0.2}
    />
    <path
      fill="#fff"
      d="m231.151 143.997-1.682.554.112.34 1.682-.554-.112-.34Z"
      opacity={0.4}
    />
    <path
      fill="#fff"
      d="m231.151 143.997-1.682.554.112.34 1.682-.554-.112-.34Z"
      opacity={0.2}
    />
    <path
      fill="#fff"
      d="m233.533 151.23-1.681.555.112.34 1.682-.554-.113-.341Z"
      opacity={0.4}
    />
    <path
      fill="#fff"
      d="m233.533 151.23-1.681.555.112.34 1.682-.554-.113-.341Z"
      opacity={0.2}
    />
    <path
      fill="#000"
      d="m221.475 120.3.926-.304-.96.196.034.108Z"
      opacity={0.2}
    />
    <path
      fill="#fff"
      d="m221.475 120.3.926-.304-.96.196.034.108Z"
      opacity={0.2}
    />
    <path
      fill="#000"
      d="m224.975 125.278-1.682.554.554 1.682 1.682-.555-.554-1.681Z"
      opacity={0.2}
    />
    <path
      fill="#fff"
      d="m224.975 125.278-1.682.554.554 1.682 1.682-.555-.554-1.681Z"
      opacity={0.2}
    />
    <path
      fill="#000"
      d="m227.354 132.446-1.682.554.555 1.681 1.682-.554-.555-1.681Z"
      opacity={0.2}
    />
    <path
      fill="#fff"
      d="m227.354 132.446-1.682.554.555 1.681 1.682-.554-.555-1.681Z"
      opacity={0.2}
    />
    <path
      fill="#000"
      d="m229.733 139.625-1.682.555.554 1.681 1.682-.554-.554-1.682Z"
      opacity={0.2}
    />
    <path
      fill="#fff"
      d="m229.733 139.625-1.682.555.554 1.681 1.682-.554-.554-1.682Z"
      opacity={0.2}
    />
    <path
      fill="#000"
      d="m232.088 146.864-1.682.554.555 1.681 1.682-.554-.555-1.681Z"
      opacity={0.2}
    />
    <path
      fill="#fff"
      d="m232.088 146.864-1.682.554.555 1.681 1.682-.554-.555-1.681Z"
      opacity={0.2}
    />
    <path
      fill="#000"
      d="m234.467 154.031-1.682.555.555 1.681 1.682-.554-.555-1.682Z"
      opacity={0.2}
    />
    <path
      fill="#fff"
      d="m234.467 154.031-1.682.555.555 1.681 1.682-.554-.555-1.682ZM238.467 141.953l-1.682.555.83 2.515 1.682-.554-.83-2.516ZM232.733 124.551l-1.682.554.853 2.587 1.682-.555-.853-2.586ZM231.303 120.29l-1.682.554.865 2.625 1.683-.554-.866-2.625ZM239.85 146.149l-1.682.554.887 2.689 1.682-.554-.887-2.689ZM236.084 134.719l-1.682.554.843 2.555 1.682-.555-.843-2.554ZM237.479 138.949l-1.682.555.876 2.657 1.682-.555-.876-2.657ZM240.539 153.898l.041.135 1.683-.541-.047-.148-1.677.554ZM231.075 119.966c-.447-.331-.676-.493-.676-.493-.406 0-.805-.034-1.204-.047l.345 1.054 1.535-.514ZM233.694 127.481l-1.682.554.853 2.586 1.682-.554-.853-2.586ZM240.846 149.188l-1.682.554.819 2.484 1.682-.555-.819-2.483ZM235.108 131.746l-1.682.555.864 2.618 1.682-.554-.864-2.619Z"
      opacity={0.2}
    />
    <path
      fill="#fff"
      d="m229.627 120.82 1.676-.554-.054-.169-.176-.128-1.561.513.115.338Z"
      opacity={0.4}
    />
    <path
      fill="#fff"
      d="m229.627 120.82 1.676-.554-.054-.169-.176-.128-1.561.513.115.338Z"
      opacity={0.2}
    />
    <path
      fill="#fff"
      d="m233.588 127.133-1.682.555.112.34 1.682-.555-.112-.34Z"
      opacity={0.4}
    />
    <path
      fill="#fff"
      d="m233.588 127.133-1.682.555.112.34 1.682-.555-.112-.34Z"
      opacity={0.2}
    />
    <path
      fill="#fff"
      d="m235.963 134.375-1.682.555.112.34 1.682-.555-.112-.34Z"
      opacity={0.4}
    />
    <path
      fill="#fff"
      d="m235.963 134.375-1.682.555.112.34 1.682-.555-.112-.34Z"
      opacity={0.2}
    />
    <path
      fill="#fff"
      d="m238.35 141.602-1.682.554.112.34 1.682-.554-.112-.34Z"
      opacity={0.4}
    />
    <path
      fill="#fff"
      d="m238.35 141.602-1.682.554.112.34 1.682-.554-.112-.34Z"
      opacity={0.2}
    />
    <path
      fill="#fff"
      d="m240.741 148.828-1.682.555.112.34 1.682-.554-.112-.341Z"
      opacity={0.4}
    />
    <path
      fill="#fff"
      d="m240.741 148.828-1.682.555.112.34 1.682-.554-.112-.341Z"
      opacity={0.2}
    />
    <path
      fill="#000"
      d="m232.178 122.879-1.682.555.555 1.681 1.682-.554-.555-1.682Z"
      opacity={0.2}
    />
    <path
      fill="#fff"
      d="m232.178 122.879-1.682.555.555 1.681 1.682-.554-.555-1.682Z"
      opacity={0.2}
    />
    <path
      fill="#000"
      d="m234.545 130.082-1.682.555.555 1.681 1.682-.554-.555-1.682Z"
      opacity={0.2}
    />
    <path
      fill="#fff"
      d="m234.545 130.082-1.682.555.555 1.681 1.682-.554-.555-1.682Z"
      opacity={0.2}
    />
    <path
      fill="#000"
      d="m236.924 137.258-1.682.554.555 1.682 1.682-.555-.555-1.681Z"
      opacity={0.2}
    />
    <path
      fill="#fff"
      d="m236.924 137.258-1.682.554.555 1.682 1.682-.555-.555-1.681Z"
      opacity={0.2}
    />
    <path
      fill="#000"
      d="m239.295 144.457-1.682.555.555 1.681 1.682-.554-.555-1.682Z"
      opacity={0.2}
    />
    <path
      fill="#fff"
      d="m239.295 144.457-1.682.555.555 1.681 1.682-.554-.555-1.682Z"
      opacity={0.2}
    />
    <path
      fill="#000"
      d="m241.655 151.684-1.682.554.554 1.682 1.682-.554-.554-1.682Z"
      opacity={0.2}
    />
    <path
      fill="#fff"
      d="m241.655 151.684-1.682.554.554 1.682 1.682-.554-.554-1.682ZM242.507 135.426l-.304-.676.23.71.074-.034ZM246.254 147.023h.061c-.217-.953-.447-1.865-.676-2.757l-.264.087.879 2.67ZM243.863 139.792l.345-.114c-.325-.906-.676-1.778-1.001-2.616l-.223.075.879 2.655ZM244.805 142.656l.331-.108a54.124 54.124 0 0 0-.811-2.521l-.345.115.825 2.514ZM246.468 147.688c0-.115-.048-.224-.075-.333h-.034l.109.333Z"
      opacity={0.2}
    />
    <path
      fill="#fff"
      d="m243.982 140.163.345-.115a6.64 6.64 0 0 1-.115-.345l-.345.115.115.345Z"
      opacity={0.4}
    />
    <path
      fill="#fff"
      d="m243.982 140.163.345-.115a6.64 6.64 0 0 1-.115-.345l-.345.115.115.345Z"
      opacity={0.2}
    />
    <path
      fill="#fff"
      d="M246.358 147.367h.034l-.081-.351h-.061l.108.351Z"
      opacity={0.4}
    />
    <path
      fill="#fff"
      d="M246.358 147.367h.034l-.081-.351h-.061l.108.351Z"
      opacity={0.2}
    />
    <path
      fill="#000"
      d="m242.984 137.14.223-.074c-.229-.554-.466-1.101-.676-1.628h-.074l.527 1.702Z"
      opacity={0.2}
    />
    <path
      fill="#fff"
      d="m242.984 137.14.223-.074c-.229-.554-.466-1.101-.676-1.628h-.074l.527 1.702Z"
      opacity={0.2}
    />
    <path
      fill="#000"
      d="m245.386 144.338.264-.088a65.047 65.047 0 0 0-.487-1.703l-.331.108.554 1.683Z"
      opacity={0.2}
    />
    <path
      fill="#fff"
      d="m245.386 144.338.264-.088a65.047 65.047 0 0 0-.487-1.703l-.331.108.554 1.683Z"
      opacity={0.2}
    />
    <path
      fill="#000"
      d="m205.243 128.863-.345.108.798 2.426.196.156.216-.068-.865-2.622ZM205.13 128.517l-.263-.79-.305.223.224.675.344-.108Z"
      opacity={0.3}
    />
    <path
      fill="#fff"
      d="m205.125 128.525-.34.112.112.34.341-.112-.113-.34Z"
      opacity={0.4}
    />
    <path
      fill="#000"
      d="m205.125 128.525-.34.112.112.34.341-.112-.113-.34Z"
      opacity={0.3}
    />
    <path
      fill="#000"
      d="m205.895 131.552.331.291-.115-.359-.216.068Z"
      opacity={0.2}
    />
    <path
      fill="#000"
      d="m205.895 131.552.331.291-.115-.359-.216.068ZM212.362 126.132l-.804-2.433-.331.162.79 2.386.345-.115ZM221.016 152.345l-.34.112.887 2.689.34-.112-.887-2.689ZM222.008 155.396l-.34.112.819 2.483.34-.112-.819-2.483ZM219.629 148.157l-.34.113.829 2.515.341-.112-.83-2.516ZM218.641 145.161l-.34.112.877 2.657.34-.112-.877-2.657ZM217.247 140.915l-.341.112.843 2.555.34-.113-.842-2.554ZM214.86 133.696l-.34.113.853 2.586.34-.112-.853-2.587ZM216.266 137.954l-.34.112.864 2.619.34-.112-.864-2.619ZM212.469 126.458l-.34.112.866 2.625.34-.112-.866-2.625ZM213.895 130.759l-.34.112.853 2.586.341-.112-.854-2.586Z"
      opacity={0.3}
    />
    <path
      fill="#fff"
      d="m212.368 126.118-.341.112.113.341.34-.113-.112-.34Z"
      opacity={0.4}
    />
    <path
      fill="#000"
      d="m212.368 126.118-.341.112.113.341.34-.113-.112-.34Z"
      opacity={0.3}
    />
    <path
      fill="#fff"
      d="m214.747 133.357-.341.112.112.34.341-.112-.112-.34Z"
      opacity={0.4}
    />
    <path
      fill="#000"
      d="m214.747 133.357-.341.112.112.34.341-.112-.112-.34Z"
      opacity={0.3}
    />
    <path
      fill="#fff"
      d="m217.133 140.587-.34.112.112.34.34-.112-.112-.34Z"
      opacity={0.4}
    />
    <path
      fill="#000"
      d="m217.133 140.587-.34.112.112.34.34-.112-.112-.34Z"
      opacity={0.3}
    />
    <path
      fill="#fff"
      d="m219.512 147.814-.34.112.112.34.34-.112-.112-.34Z"
      opacity={0.4}
    />
    <path
      fill="#000"
      d="m219.512 147.814-.34.112.112.34.34-.112-.112-.34Z"
      opacity={0.3}
    />
    <path
      fill="#fff"
      d="m221.891 155.056-.34.112.112.34.34-.112-.112-.34Z"
      opacity={0.4}
    />
    <path
      fill="#000"
      d="m221.891 155.056-.34.112.112.34.34-.112-.112-.34Z"
      opacity={0.3}
    />
    <path
      fill="#000"
      d="m213.336 129.099-.34.112.555 1.681.34-.112-.555-1.681Z"
      opacity={0.2}
    />
    <path
      fill="#000"
      d="m213.336 129.099-.34.112.555 1.681.34-.112-.555-1.681Z"
      opacity={0.3}
    />
    <path
      fill="#000"
      d="m215.711 136.282-.34.113.554 1.681.341-.112-.555-1.682Z"
      opacity={0.2}
    />
    <path
      fill="#000"
      d="m215.711 136.282-.34.113.554 1.681.341-.112-.555-1.682Z"
      opacity={0.3}
    />
    <path
      fill="#000"
      d="m218.09 143.466-.34.112.555 1.681.34-.112-.555-1.681Z"
      opacity={0.2}
    />
    <path
      fill="#000"
      d="m218.09 143.466-.34.112.555 1.681.34-.112-.555-1.681Z"
      opacity={0.3}
    />
    <path
      fill="#000"
      d="m220.461 150.661-.34.112.555 1.682.34-.112-.555-1.682Z"
      opacity={0.2}
    />
    <path
      fill="#000"
      d="m220.461 150.661-.34.112.555 1.682.34-.112-.555-1.682Z"
      opacity={0.3}
    />
    <path
      fill="#000"
      d="m222.488 157.986.548 1.662.345-.108-.555-1.669-.338.115Z"
      opacity={0.2}
    />
    <path
      fill="#000"
      d="m222.488 157.986.548 1.662.345-.108-.555-1.669-.338.115ZM218.75 121.185l-.34.112.841 2.548.34-.113-.841-2.547ZM229.25 152.985l-.34.113.819 2.483.341-.112-.82-2.484ZM226.868 145.759l-.341.112.83 2.516.34-.112-.829-2.516ZM225.875 142.755l-.34.112.877 2.657.34-.112-.877-2.657ZM221.125 128.372l-.34.112.853 2.587.341-.113-.854-2.586ZM222.094 131.298l-.34.112.854 2.586.34-.112-.854-2.586ZM224.473 138.54l-.34.112.842 2.555.341-.113-.843-2.554ZM230.27 157.283v.047l.344-.115v-.047l-.344.115ZM219.211 124.819l-.34.111.857 2.625.341-.111-.858-2.625ZM223.497 135.583l-.341.112.864 2.619.34-.112-.863-2.619ZM228.25 149.95l-.34.112.887 2.689.34-.112-.887-2.689Z"
      opacity={0.3}
    />
    <path
      fill="#fff"
      d="m219.594 123.739-.34.113.112.34.34-.112-.112-.341Z"
      opacity={0.4}
    />
    <path
      fill="#000"
      d="m219.594 123.739-.34.113.112.34.34-.112-.112-.341Z"
      opacity={0.3}
    />
    <path
      fill="#fff"
      d="m221.977 130.954-.34.112.112.341.34-.113-.112-.34Z"
      opacity={0.4}
    />
    <path
      fill="#000"
      d="m221.977 130.954-.34.112.112.341.34-.113-.112-.34Z"
      opacity={0.3}
    />
    <path
      fill="#fff"
      d="m224.364 138.196-.341.113.113.34.34-.112-.112-.341Z"
      opacity={0.4}
    />
    <path
      fill="#000"
      d="m224.364 138.196-.341.113.113.34.34-.112-.112-.341Z"
      opacity={0.3}
    />
    <path
      fill="#fff"
      d="m226.747 145.431-.341.112.112.34.341-.112-.112-.34Z"
      opacity={0.4}
    />
    <path
      fill="#000"
      d="m226.747 145.431-.341.112.112.34.341-.112-.112-.34Z"
      opacity={0.3}
    />
    <path
      fill="#fff"
      d="m228.552 153.428-.341.111.111.341.341-.112-.111-.34Z"
      opacity={0.4}
    />
    <path
      fill="#000"
      d="m228.552 153.428-.341.111.111.341.341-.112-.111-.34Z"
      opacity={0.3}
    />
    <path
      fill="#000"
      d="m218.751 121.199-.102-.304-.344.101.101.317.345-.114Z"
      opacity={0.2}
    />
    <path
      fill="#000"
      d="m218.751 121.199-.102-.304-.344.101.101.317.345-.114Z"
      opacity={0.3}
    />
    <path
      fill="#000"
      d="m220.571 126.712-.341.112.555 1.682.34-.113-.554-1.681Z"
      opacity={0.2}
    />
    <path
      fill="#000"
      d="m220.571 126.712-.341.112.555 1.682.34-.113-.554-1.681Z"
      opacity={0.3}
    />
    <path
      fill="#000"
      d="m222.942 133.903-.34.113.554 1.681.34-.112-.554-1.682Z"
      opacity={0.2}
    />
    <path
      fill="#000"
      d="m222.942 133.903-.34.113.554 1.681.34-.112-.554-1.682Z"
      opacity={0.3}
    />
    <path
      fill="#000"
      d="m225.309 141.114-.34.113.554 1.681.34-.112-.554-1.682Z"
      opacity={0.2}
    />
    <path
      fill="#000"
      d="m225.309 141.114-.34.113.554 1.681.34-.112-.554-1.682Z"
      opacity={0.3}
    />
    <path
      fill="#000"
      d="m227.684 148.298-.34.112.554 1.682.341-.113-.555-1.681Z"
      opacity={0.2}
    />
    <path
      fill="#000"
      d="m227.684 148.298-.34.112.554 1.682.341-.113-.555-1.681Z"
      opacity={0.3}
    />
    <path
      fill="#000"
      d="m230.059 155.485-.34.113.554 1.681.341-.112-.555-1.682Z"
      opacity={0.2}
    />
    <path
      fill="#000"
      d="m230.059 155.485-.34.113.554 1.681.341-.112-.555-1.682ZM234.907 148.389l-.341.111.878 2.69.341-.111-.878-2.69ZM233.11 140.372l-.34.112.876 2.657.341-.112-.877-2.657ZM236.469 150.618l-.34.112.819 2.484.34-.112-.819-2.484ZM231.719 136.142l-.34.112.843 2.554.34-.112-.843-2.554ZM226.93 121.732l-.34.112.865 2.625.341-.112-.866-2.625ZM237.504 154.896l.034.108.344-.108v-.115l-.378.115ZM226.82 121.369l-.615-1.865-.365.034.676 1.939.304-.108ZM234.094 143.384l-.34.112.829 2.516.341-.112-.83-2.516ZM228.352 126.009l-.34.112.853 2.586.34-.112-.853-2.586ZM230.735 133.185l-.34.112.863 2.618.341-.112-.864-2.618ZM229.325 128.935l-.341.112.854 2.586.34-.112-.853-2.586Z"
      opacity={0.3}
    />
    <path
      fill="#fff"
      d="m226.821 121.38-.341.112.113.34.34-.112-.112-.34Z"
      opacity={0.4}
    />
    <path
      fill="#000"
      d="m226.821 121.38-.341.112.113.34.34-.112-.112-.34Z"
      opacity={0.3}
    />
    <path
      fill="#fff"
      d="m229.204 128.591-.341.112.112.34.341-.112-.112-.34Z"
      opacity={0.4}
    />
    <path
      fill="#000"
      d="m229.204 128.591-.341.112.112.34.341-.112-.112-.34Z"
      opacity={0.3}
    />
    <path
      fill="#fff"
      d="m231.586 135.833-.34.112.112.34.341-.112-.113-.34Z"
      opacity={0.4}
    />
    <path
      fill="#000"
      d="m231.586 135.833-.34.112.112.34.341-.112-.113-.34Z"
      opacity={0.3}
    />
    <path
      fill="#fff"
      d="m233.985 143.032-.34.113.112.34.34-.113-.112-.34Z"
      opacity={0.4}
    />
    <path
      fill="#000"
      d="m233.985 143.032-.34.113.112.34.34-.113-.112-.34Z"
      opacity={0.3}
    />
    <path
      fill="#fff"
      d="m236.356 150.294-.34.112.112.34.34-.112-.112-.34Z"
      opacity={0.4}
    />
    <path
      fill="#000"
      d="m236.356 150.294-.34.112.112.34.34-.112-.112-.34Z"
      opacity={0.3}
    />
    <path
      fill="#000"
      d="m227.805 124.302-.34.112.554 1.681.341-.112-.555-1.681Z"
      opacity={0.2}
    />
    <path
      fill="#000"
      d="m227.805 124.302-.34.112.554 1.681.341-.112-.555-1.681Z"
      opacity={0.3}
    />
    <path
      fill="#000"
      d="m230.176 131.521-.34.112.554 1.681.341-.112-.555-1.681Z"
      opacity={0.2}
    />
    <path
      fill="#000"
      d="m230.176 131.521-.34.112.554 1.681.341-.112-.555-1.681Z"
      opacity={0.3}
    />
    <path
      fill="#000"
      d="m232.551 138.72-.34.112.555 1.681.34-.112-.555-1.681Z"
      opacity={0.2}
    />
    <path
      fill="#000"
      d="m232.551 138.72-.34.112.555 1.681.34-.112-.555-1.681Z"
      opacity={0.3}
    />
    <path
      fill="#000"
      d="m234.34 146.764-.34.111.549 1.682.34-.111-.549-1.682Z"
      opacity={0.2}
    />
    <path
      fill="#000"
      d="m234.34 146.764-.34.111.549 1.682.34-.111-.549-1.682Z"
      opacity={0.3}
    />
    <path
      fill="#000"
      d="m237.286 153.126-.341.112.555 1.682.34-.112-.554-1.682Z"
      opacity={0.2}
    />
    <path
      fill="#000"
      d="m237.286 153.126-.341.112.555 1.682.34-.112-.554-1.682ZM241.317 141.005l-.34.112.829 2.516.34-.112-.829-2.516ZM244.711 152.51l.054.169.345-.108-.054-.169-.345.108ZM236.44 126.21l-.494-1.5-.622-.73.771 2.345.345-.115ZM242.704 145.204l-.341.112.887 2.689.341-.112-.887-2.689ZM237.965 130.798l-.34.112.864 2.618.34-.112-.864-2.618ZM240.332 138.001l-.34.112.877 2.657.34-.112-.877-2.657ZM238.946 133.763l-.341.112.843 2.554.341-.112-.843-2.554ZM243.711 148.224l-.34.112.82 2.483.34-.112-.82-2.483ZM236.559 126.552l-.34.112.852 2.586.341-.112-.853-2.586Z"
      opacity={0.3}
    />
    <path
      fill="#fff"
      d="m236.442 126.189-.34.112.112.34.34-.112-.112-.34Z"
      opacity={0.4}
    />
    <path
      fill="#000"
      d="m236.442 126.189-.34.112.112.34.34-.112-.112-.34Z"
      opacity={0.3}
    />
    <path
      fill="#fff"
      d="m238.832 133.415-.34.112.112.34.341-.112-.113-.34Z"
      opacity={0.4}
    />
    <path
      fill="#000"
      d="m238.832 133.415-.34.112.112.34.341-.112-.113-.34Z"
      opacity={0.3}
    />
    <path
      fill="#fff"
      d="m241.211 140.657-.34.113.112.34.341-.112-.113-.341Z"
      opacity={0.4}
    />
    <path
      fill="#000"
      d="m241.211 140.657-.34.113.112.34.341-.112-.113-.341Z"
      opacity={0.3}
    />
    <path
      fill="#fff"
      d="m243.586 147.904-.34.112.112.34.341-.112-.113-.34Z"
      opacity={0.4}
    />
    <path
      fill="#000"
      d="m243.586 147.904-.34.112.112.34.341-.112-.113-.34Z"
      opacity={0.3}
    />
    <path
      fill="#000"
      d="m237.407 129.134-.341.112.555 1.682.34-.113-.554-1.681Z"
      opacity={0.2}
    />
    <path
      fill="#000"
      d="m237.407 129.134-.341.112.555 1.682.34-.113-.554-1.681Z"
      opacity={0.3}
    />
    <path
      fill="#000"
      d="m239.786 136.325-.341.113.555 1.681.34-.112-.554-1.682Z"
      opacity={0.2}
    />
    <path
      fill="#000"
      d="m239.786 136.325-.341.113.555 1.681.34-.112-.554-1.682Z"
      opacity={0.3}
    />
    <path
      fill="#000"
      d="m242.161 143.501-.341.112.555 1.682.341-.113-.555-1.681Z"
      opacity={0.2}
    />
    <path
      fill="#000"
      d="m242.161 143.501-.341.112.555 1.682.341-.113-.555-1.681Z"
      opacity={0.3}
    />
    <path
      fill="#000"
      d="m244.539 150.696-.34.113.555 1.681.34-.112-.555-1.682Z"
      opacity={0.2}
    />
    <path
      fill="#000"
      d="m244.539 150.696-.34.113.555 1.681.34-.112-.555-1.682Z"
      opacity={0.3}
    />
    <path
      fill="#000"
      d="M214.595 142.27a33.015 33.015 0 0 0-4.888-7.048c1.149-1.081 2.832-1.723 5.158-1.521.759 2.82.665 5.802-.27 8.569Z"
      opacity={0.2}
    />
    <path
      fill="#6C7DC0"
      d="m212.591 143.273-12.634-2.101.074 2.831 12.25 1.203.31-1.933Z"
    />
    <path
      fill="#fff"
      d="m212.591 143.273-12.634-2.101.074 2.831 12.25 1.203.31-1.933Z"
      opacity={0.2}
    />
    <path
      fill="#6C7DC0"
      d="m263.391 158.947.913 1.54a.941.941 0 0 1-.298 1.277l-80.498 51.985-1.879-3.176 80.444-51.937a.935.935 0 0 1 .725-.122.957.957 0 0 1 .593.433Z"
    />
    <path
      fill="#000"
      d="m263.391 158.947.913 1.54a.941.941 0 0 1-.298 1.277l-80.498 51.985-1.879-3.176 80.444-51.937a.935.935 0 0 1 .725-.122.957.957 0 0 1 .593.433Z"
      opacity={0.2}
    />
    <path
      fill="#263238"
      d="M179.619 212.296s-6.395-9.326-4.414-19.198a55.713 55.713 0 0 0 8.436 16.826l-4.022 2.372Z"
    />
    <path
      fill="#fff"
      d="M179.619 212.296s-6.395-9.326-4.414-19.198a55.713 55.713 0 0 0 8.436 16.826l-4.022 2.372Z"
      opacity={0.5}
    />
    <path
      fill="#263238"
      d="M180.953 214.567s5.097 10.103 14.696 13.13a55.916 55.916 0 0 1-10.674-15.502l-4.022 2.372Z"
    />
    <path
      fill="#fff"
      d="M180.953 214.567s5.097 10.103 14.696 13.13a55.916 55.916 0 0 1-10.674-15.502l-4.022 2.372Z"
      opacity={0.5}
    />
    <path
      fill="#263238"
      d="m178.491 211.86 2.318 3.921 5.79-3.42-2.318-3.921-5.79 3.42Z"
    />
    <path
      fill="#fff"
      d="m178.491 211.86 2.318 3.921 5.79-3.42-2.318-3.921-5.79 3.42Z"
      opacity={0.3}
    />
    <path
      fill="#FFC3BD"
      d="m254.616 158.488-.061 6.92 5.982-.912s.724-4.832-2.778-6.832l-3.143.824Z"
    />
    <path
      fill="#FFC3BD"
      d="m256.069 167.817 5.056.209-.588-3.534-5.982.912 1.514 2.413ZM273.241 213.66l.311 4.947-11.431 1.196-.305-4.947 11.425-1.196Z"
    />
    <path
      fill="#6C7DC0"
      d="M273.776 218.812a.112.112 0 0 0-.057-.041.123.123 0 0 0-.071 0 .108.108 0 0 0-.081.102c0 .088-.142 2.074.419 2.703.102.122.247.2.406.216a.435.435 0 0 0 .466-.216c.169-.311 0-.899-.291-1.473a8.927 8.927 0 0 0-.791-1.291Zm0 .419c.521.777 1.062 1.906.872 2.25 0 .047-.074.108-.243.095a.348.348 0 0 1-.25-.135.795.795 0 0 1-.122-.196 5.452 5.452 0 0 1-.257-2.021v.007Z"
    />
    <path
      fill="#6C7DC0"
      d="M273.74 218.777a.131.131 0 0 0-.122 0c-.047 0-1.189.73-1.385 1.52a.903.903 0 0 0 .101.676c.176.277.358.291.487.25.547-.162.993-1.696.98-2.351a.13.13 0 0 0 0-.048.185.185 0 0 0-.061-.047Zm-1.278 1.581a2.777 2.777 0 0 1 1.096-1.25c-.068.71-.474 1.798-.805 1.899 0 0-.108.034-.216-.149a.61.61 0 0 1-.075-.5Z"
    />
    <path
      fill="#263238"
      d="m272.934 218.651-2.352-4.838a.432.432 0 0 1 .122-.528l3.542-2.797a.72.72 0 0 1 1.102.257c.818 1.777 1.947 4.365 3.015 6.575 1.244 2.588 2.46 4.73 3.927 7.777.886 1.832-.723 3.237-1.264 2.555-2.447-3.129-3.907-5.94-7.226-8.055a2.297 2.297 0 0 1-.866-.946ZM268.792 222.633s-36.565 6.487-48.057 3.304c-7.193-1.993-7.436-21.286-6.084-38.814.392-5.19.94-10.224 1.474-14.61 1.041-8.494 2.068-14.549 2.068-14.549l29.116-6.433s2.535 11.191-1.244 19.779a15.128 15.128 0 0 1-9.505 8.717s-2.562 8.184-4.597 16.522c-1.859 7.629-3.292 15.387-1.926 17.151 2.028 2.608 38.309-.034 38.309-.034l.446 8.967Z"
    />
    <path
      fill="#FAFAFA"
      d="M268.792 222.633s-36.565 6.487-48.057 3.304c-7.193-1.993-7.436-21.286-6.084-38.814.392-5.19.94-10.224 1.474-14.61 1.041-8.494 2.068-14.549 2.068-14.549l29.116-6.433s2.535 11.191-1.244 19.779a15.128 15.128 0 0 1-9.505 8.717s-2.562 8.184-4.597 16.522c-1.859 7.629-3.292 15.387-1.926 17.151 2.028 2.608 38.309-.034 38.309-.034l.446 8.967Z"
      opacity={0.2}
    />
    <path
      fill="#000"
      d="M215.267 180.422a303.266 303.266 0 0 0-.595 6.703c4.123 2.784 11.221 7.048 17.285 9.42 1.771-7.257 3.935-14.386 4.469-16.123h-21.159Z"
      opacity={0.2}
    />
    <path
      fill="#6C7DC0"
      d="M208.022 222.75a.122.122 0 0 0 .094-.094.105.105 0 0 0-.009-.072.105.105 0 0 0-.052-.05c-.074-.041-1.804-1.034-2.629-.804a.548.548 0 0 0-.372.27.445.445 0 0 0 0 .514c.203.29.818.371 1.453.371a8.945 8.945 0 0 0 1.515-.135Zm-.379-.176c-.926.129-2.177.122-2.406-.196-.034-.04-.061-.114 0-.263a.366.366 0 0 1 .263-.189.806.806 0 0 1 .23 0c.675.1 1.325.33 1.913.675v-.027Z"
    />
    <path
      fill="#6C7DC0"
      d="M208.074 222.726a.112.112 0 0 0 .038-.048.104.104 0 0 0 .009-.06c0-.054-.142-1.392-.77-1.906a.824.824 0 0 0-.676-.203c-.325 0-.42.196-.44.325-.088.561 1.095 1.635 1.697 1.905h.047a.131.131 0 0 0 .095-.013Zm-.872-1.838c.375.431.611.966.676 1.534-.609-.372-1.42-1.21-1.352-1.548 0 0 0-.108.23-.135h.074a.616.616 0 0 1 .372.149Z"
    />
    <path
      fill="#FFC3BD"
      d="m213.997 222.402-4.61 1.824-4.692-10.487 4.611-1.825 4.691 10.488Z"
    />
    <path
      fill="#263238"
      d="M208.529 222.063h5.408a.42.42 0 0 1 .419.337l.981 4.406a.722.722 0 0 1-.717.879c-1.954 0-4.773-.142-7.226-.142-2.873 0-5.354.155-8.721.155-2.028 0-2.596-2.061-1.744-2.243 3.88-.852 7.044-.94 10.397-3.007a2.295 2.295 0 0 1 1.203-.385ZM247.257 151.891l-2.326 22.184c-1.149 2.642-7.287 7.487-10.18 7.859a69.954 69.954 0 0 1-7.071.473c-4.11.095-8.498-.047-12.486-.236-2.555-.122-4.942-.271-6.99-.392-3.731-.217-6.334-.352-6.699-.122-1.352.838 11.1 35.078 11.1 35.078l-7.639.162s-17.042-29.199-18.624-38.896c-.588-3.581-1.088-8.041 5.733-11.487 4.157-2.088 15.663-2.994 22.308-3.379 2.94-.155 4.934-.203 4.934-.203l-.209-.919-.913-4.095 29.062-6.027Z"
    />
    <path
      fill="#FAFAFA"
      d="m247.257 151.891-2.326 22.184c-1.149 2.642-7.287 7.487-10.18 7.859a69.954 69.954 0 0 1-7.071.473c-4.11.095-8.498-.047-12.486-.236-2.555-.122-4.942-.271-6.99-.392-3.731-.217-6.334-.352-6.699-.122-1.352.838 11.1 35.078 11.1 35.078l-7.639.162s-17.042-29.199-18.624-38.896c-.588-3.581-1.088-8.041 5.733-11.487 4.157-2.088 15.663-2.994 22.308-3.379 2.94-.155 4.934-.203 4.934-.203l-.209-.919-.913-4.095 29.062-6.027Z"
      opacity={0.2}
    />
    <path
      fill="#000"
      d="m235.355 165.074 5.659-1.101a62.155 62.155 0 0 1 0 7.325l-2.772 1.926-2.325-1.014a62.886 62.886 0 0 0-.562-7.136Z"
      opacity={0.2}
    />
    <path
      fill="#000"
      d="m220.02 158.172.48 2.331-2.785.561.203-2.446 2.102-.446ZM229.699 156.129l.52 2.419-8.666 1.743-.514-2.338 8.66-1.824ZM240.5 153.852l.513 2.527-9.693 1.946-.508-2.433 9.688-2.04ZM248.11 154.945l-5.969 1.202h-.007l-.521-2.534 5.929-1.25.568 2.582Z"
    />
    <path
      fill="#FFC3BD"
      d="m185.948 152.319-3.001-1.817a2.699 2.699 0 0 0-2.461-.21l-1.98.838a2.705 2.705 0 0 0-1.467 3.419l.567 1.5a2.7 2.7 0 0 0 2.028 1.69l3.293.635s3.123-.176 4.603-2.406l-1.582-3.649Z"
    />
    <path
      fill="#FFC3BD"
      d="M213.037 131.554a149.589 149.589 0 0 1-2.887 15.414 35.57 35.57 0 0 1-1.9 6.081c-3.211 6.798-17.258 4.73-23.254 3.642l.298-4.426c3.319-.337 6.719-.675 9.896-1.182 2.082-.379 4.333-.723 5.962-1.683.136-.094.203-.182.082-.108-.1.074-.185.166-.251.27-.06.075-.128.217-.108.156.021-.061 0 0 0-.068 1.352-6.21 2.13-13.15 3.299-19.427l8.849 1.351.014-.02Z"
    />
    <path
      fill="#6C7DC0"
      d="m201.445 132.51-.554 11.224 10.89.675a55.887 55.887 0 0 0 3.022-12.203c.743-7.143-11.715-6.866-13.358.304Z"
    />
    <path
      fill="#fff"
      d="m204.374 131.059-.327 2.812.356.041.327-2.812-.356-.041ZM204.021 134.254l-.302 2.598.356.041.302-2.598-.356-.041ZM204.932 129.348l.156-1.352-.385.216-.129 1.095.358.041ZM203.507 138.611l-.331 2.846.356.041.331-2.846-.356-.041ZM203.123 141.797l-.236 2.068.358.02.237-2.048-.359-.04ZM211.556 135.094l-.302 2.597.356.042.301-2.598-.355-.041ZM211.948 131.957l-.327 2.813.356.041.327-2.813-.356-.041ZM211.041 139.451l-.33 2.846.356.041.33-2.846-.356-.041ZM212.499 130.225l.27-2.325a3.28 3.28 0 0 0-.338-.189l-.29 2.473.358.041ZM210.684 142.676l-.196 1.682.365.027.19-1.669-.359-.04Z"
      opacity={0.4}
    />
    <path
      fill="#000"
      d="m206.565 138.955-.331 2.846 1.76.204.331-2.846-1.76-.204ZM207.448 131.426l-.327 2.812 1.759.205.327-2.813-1.759-.204ZM209.395 129.866l.311-2.636-1.514-.175-.25.033-.297 2.575 1.75.203ZM206.192 142.152l-.223 1.906 1.764.115.216-1.818-1.757-.203ZM207.068 134.59l-.302 2.598 1.759.204.302-2.598-1.759-.204Z"
      opacity={0.2}
    />
    <path
      fill="#fff"
      d="m208.537 137.394-.205 1.758 2.74.319.204-1.759-2.739-.318ZM204.06 136.87l-.205 1.759 2.707.314.204-1.758-2.706-.315ZM203.706 136.828l-2.427-.277-.088 1.763 2.312.271.203-1.757ZM211.422 139.485l1.906.223c.149-.548.304-1.129.453-1.724l-2.156-.25-.203 1.751Z"
      opacity={0.2}
    />
    <path
      fill="#fff"
      d="m203.713 136.843-.205 1.759.356.041.204-1.759-.355-.041Z"
      opacity={0.4}
    />
    <path
      fill="#fff"
      d="m203.713 136.843-.205 1.759.356.041.204-1.759-.355-.041Z"
      opacity={0.2}
    />
    <path
      fill="#fff"
      d="m211.279 137.726-.205 1.758.356.042.205-1.759-.356-.041Z"
      opacity={0.4}
    />
    <path
      fill="#fff"
      d="m211.279 137.726-.205 1.758.356.042.205-1.759-.356-.041Z"
      opacity={0.2}
    />
    <path
      fill="#000"
      d="m206.771 137.195-.205 1.758 1.76.205.204-1.759-1.759-.204Z"
      opacity={0.2}
    />
    <path
      fill="#fff"
      d="m206.771 137.195-.205 1.758 1.76.205.204-1.759-1.759-.204ZM204.373 131.064l.203-1.757-1.163-.135a6.576 6.576 0 0 0-1.284 1.628l2.244.264ZM212.293 131.983l2.528.291v-.034a5.298 5.298 0 0 0-.115-1.757l-2.217-.256-.196 1.756ZM209.384 129.851l-.204 1.758 2.739.318.205-1.758-2.74-.318ZM204.919 129.323l-.204 1.759 2.706.314.204-1.758-2.706-.315Z"
      opacity={0.2}
    />
    <path
      fill="#fff"
      d="m204.564 129.284-.205 1.759.356.041.204-1.758-.355-.042Z"
      opacity={0.4}
    />
    <path
      fill="#fff"
      d="m204.564 129.284-.205 1.759.356.041.204-1.758-.355-.042Z"
      opacity={0.2}
    />
    <path
      fill="#fff"
      d="m212.142 130.183-.204 1.758.355.042.205-1.759-.356-.041Z"
      opacity={0.4}
    />
    <path
      fill="#fff"
      d="m212.142 130.183-.204 1.758.355.042.205-1.759-.356-.041Z"
      opacity={0.2}
    />
    <path
      fill="#000"
      d="m207.634 129.648-.204 1.758 1.759.205.204-1.759-1.759-.204Z"
      opacity={0.2}
    />
    <path
      fill="#fff"
      d="m207.634 129.648-.204 1.758 1.759.205.204-1.759-1.759-.204Z"
      opacity={0.2}
    />
    <path
      fill="#000"
      d="m211.047 142.714 1.318.155c.041-.115.074-.23.115-.351l-1.386-.163-.047.359ZM203.17 141.438l-2.122-.25-.021.364 2.096.244.047-.358ZM208.002 142.011l-.041.356 2.74.319.041-.356-2.74-.319ZM203.541 141.5l-.041.355 2.706.315.041-.356-2.706-.314Z"
      opacity={0.3}
    />
    <path
      fill="#fff"
      d="m203.186 141.453-.041.356.355.041.042-.356-.356-.041Z"
      opacity={0.4}
    />
    <path
      fill="#000"
      d="m203.186 141.453-.041.356.355.041.042-.356-.356-.041Z"
      opacity={0.3}
    />
    <path
      fill="#fff"
      d="m210.748 142.34-.041.355.356.042.041-.356-.356-.041Z"
      opacity={0.4}
    />
    <path
      fill="#000"
      d="m210.748 142.34-.041.355.356.042.041-.356-.356-.041Z"
      opacity={0.3}
    />
    <path
      fill="#000"
      d="m206.241 141.812-.042.356 1.76.204.041-.355-1.759-.205Z"
      opacity={0.2}
    />
    <path
      fill="#000"
      d="m206.241 141.812-.042.356 1.76.204.041-.355-1.759-.205ZM204.046 133.874l-2.63-.304-.014.358 2.596.305.048-.359ZM208.862 134.433l-.042.356 2.74.318.041-.355-2.739-.319ZM211.922 135.155l2.427.284c0-.122.04-.237.067-.358l-2.447-.284-.047.358ZM204.409 133.933l-.042.356 2.706.314.042-.355-2.706-.315Z"
      opacity={0.3}
    />
    <path
      fill="#fff"
      d="m204.037 133.863-.041.356.356.041.041-.356-.356-.041Z"
      opacity={0.4}
    />
    <path
      fill="#000"
      d="m204.037 133.863-.041.356.356.041.041-.356-.356-.041Z"
      opacity={0.3}
    />
    <path
      fill="#fff"
      d="m211.623 134.773-.041.356.356.041.041-.355-.356-.042Z"
      opacity={0.4}
    />
    <path
      fill="#000"
      d="m211.623 134.773-.041.356.356.041.041-.355-.356-.042Z"
      opacity={0.3}
    />
    <path
      fill="#000"
      d="m207.116 134.242-.042.356 1.76.204.041-.356-1.759-.204Z"
      opacity={0.2}
    />
    <path
      fill="#000"
      d="m207.116 134.242-.042.356 1.76.204.041-.356-1.759-.204ZM211.952 127.491a7.366 7.366 0 0 0-2.218-.479v.223l2.218.256Z"
      opacity={0.3}
    />
    <path
      fill="#000"
      d="M209.733 127.009a9.133 9.133 0 0 0-1.542.048l1.515.175.027-.223Z"
      opacity={0.2}
    />
    <path
      fill="#000"
      d="M209.733 127.009a9.133 9.133 0 0 0-1.542.048l1.515.175.027-.223Z"
      opacity={0.3}
    />
    <path
      fill="#fff"
      d="m175.027 136.348 3.151-7.642s-4.631 1.554-4.732-3.987c0 0-2.556 7.784-8.822 2.878 0 0-.467 5.46-2.028 7.271-1.562 1.811-4.901 1.892-4.901 1.892s2.352 2.474 2.4 3.886c.047 1.412-2.529 3.007-2.529 3.007l6.544 1.865s-2.562-.52-2.44-3.798c.121-3.277 3.414-8.392 8.625-10.278 5.212-1.885 6.673-.128 4.732 4.906Z"
    />
  </svg>
);
export default Svg404Error;
